import { render } from "./AccountRolePanel.vue?vue&type=template&id=7a46e6fb&scoped=true"
import script from "./AccountRolePanel.vue?vue&type=script&lang=js"
export * from "./AccountRolePanel.vue?vue&type=script&lang=js"

import "./AccountRolePanel.vue?vue&type=style&index=0&id=7a46e6fb&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7a46e6fb"

export default script